import { useState } from "react";
import { FeatureProps } from "../types";
import { generateDraftReply } from "./draft-reply.service";

export function DraftReplyAction({
  emailSubject,
  emailBody,
  senderEmail,
  senderName,
}: Readonly<FeatureProps>) {
  const [draft, setDraft] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleGenerate() {
    setLoading(true);
    setError(null);
    setDraft(null);

    try {
      const result = await generateDraftReply({
        emailSubject,
        emailBody,
        senderName,
        senderEmail,
      });
      setDraft(result.draft);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to generate draft.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex flex-col gap-3">
      <button className="btn-primary self-start" onClick={handleGenerate} disabled={loading}>
        {loading ? "Generating..." : "Generate Draft Reply"}
      </button>

      {error && <p className="error-text">{error}</p>}

      {draft && (
        <div className="flex flex-col gap-2 animate-[var(--animate-fade-in)]">
          <p className="body-small-medium" style={{ color: "var(--color-text-400)" }}>
            Draft Reply
          </p>
          <pre
            className="body-regular rounded-lg p-3 whitespace-pre-wrap break-words"
            style={{
              background: "var(--color-white)",
              border: "1px solid var(--color-neutral-200)",
              color: "var(--color-text)",
            }}
          >
            {draft}
          </pre>
          <button
            className="btn-secondary self-start"
            onClick={() => navigator.clipboard.writeText(draft)}
          >
            Copy to clipboard
          </button>
        </div>
      )}
    </div>
  );
}
